import { useEffect, useState } from "react";
import { ConfirmationDialog } from "../../../ui/components/ConfirmationDialog";
import { StatusReasonForm } from "../StatusReasonForm";
import { useChangeStatusReason } from "../../hooks/useChangeStatusReason";

export type Props = {
  onClose: (reason: "changeStatusReason" | "cancel") => void;
  open: boolean;
  statusReason: string;
  verificationId: string;
  request: () => void;
};

export const ChangeStatusReasonDialog = (props: Props) => {
  const { onClose, open, verificationId, statusReason } = props;
  const [
    result,
    loading,
    error,
    changeStatusReason,
    validationErrors,
    setValidationErrors,
  ] = useChangeStatusReason();

  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");

  const handleClose = () => {
    setValidationErrors({});
    onClose("cancel");
  };

  useEffect(() => {
    if (open) {
      const reasons = statusReason.split(":");
      setReason(reasons[0]);
      setOtherReason(reasons[1]);
    }
  }, [statusReason, open]);

  useEffect(() => {
    if (result) {
      onClose("changeStatusReason");
    }
  }, [result, onClose]);

  return (
    <ConfirmationDialog
      title='Reason for decision'
      error={error}
      confirmText='Save'
      confirmAction={() =>
        changeStatusReason(verificationId, reason, otherReason)
      }
      disabled={loading}
      onClose={handleClose}
      isOpen={open}
      confirmButtonColor='primary'
    >
      <StatusReasonForm
        reason={reason}
        otherReason={otherReason}
        setReason={setReason}
        setOtherReason={setOtherReason}
        validationErrors={validationErrors}
      />
    </ConfirmationDialog>
  );
};
